<script lang="ts">
  import { _ } from "svelte-i18n";
  import type { MoneyV2 } from "$lib/gql/gen/codegen";
  import Button from "$lib/components/Button/Button.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import cfg from "$lib/config/config";
  import Link from "$lib/components/Link/Link.svelte";

  export let totalPrice: MoneyV2;
  export let continueButton = true;
</script>

<style lang="scss">
  .totals {
    &--price {
      justify-content: space-between;
      display: flex;
      margin-bottom: 32px;
    }
    &--button {
      &__checkout {
        margin-bottom: 24px;
      }
      &__shop {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>

<div class="totals">
  <div class="totals--price">
    <div class="totals--price__label">
      <Typography component="span" variant="body1"
        >{$_("Total before shipping")}
      </Typography>
    </div>
    <Typography component="span" variant="body1-emphasise">
      {new Intl.NumberFormat(cfg.CURRENCY_LOCALE, {
        style: "currency",
        currency: totalPrice.currencyCode,
      }).format(totalPrice.amount)}
    </Typography>
  </div>
  <div class="totals--button__checkout">
    <Button
      label={$_("Check out securely")}
      primary
      on:click
      fullWidth={true}
    />
  </div>
  {#if continueButton}
    <div class="totals--button__shop">
      <Link href="/" text={$_("Continue shopping")} />
    </div>
  {/if}
</div>
